import React from 'react';
import { CreditCardIcon, DownloadIcon, InfinityIcon, RepeatIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const reassurances = [{
  icon: CreditCardIcon,
  label: 'Paiement unique'
}, {
  icon: RepeatIcon,
  label: 'Aucun abonnement'
}, {
  icon: DownloadIcon,
  label: 'Accès numérique immédiat'
}, {
  icon: InfinityIcon,
  label: 'Accès à vie'
}];
export function Hero() {
  return <section className="w-full bg-paper px-5 pb-6 pt-6 sm:pb-12 sm:pt-10" data-id="element-126" data-mp="129qvxpsonxpz">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-127" data-mp="xanpq20yvlgf">
        <span className="mb-4 inline-block rounded-full border border-cobalt bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep sm:mb-6" data-id="element-128" data-mp="x8jojrugd0ju">
          Pour les professeurs de physique-chimie
        </span>

        <h1 className="font-serif-display text-[26px] font-bold leading-tight text-ink sm:text-5xl md:text-6xl" data-id="element-129" data-mp="3d2l9jc5qb50p">
          Toute votre année de chimie — organisée et prête pour vos cours en moins de 5 minutes.
        </h1>

        <p className="mt-3 text-base font-medium text-cobalt-deep sm:mt-5 sm:text-xl" data-id="element-130" data-mp="3j928hxbf86zr">
          5 volumes pédagogiques + 4 ressources complémentaires · 460 pages très visuelles ·
          Activités, évaluations et corrigés prêts à imprimer ou à projeter.
        </p>

        <p className="mt-3 text-[13px] font-semibold text-ink/70 sm:mt-4 sm:text-sm" data-id="element-131" data-mp="3e8efx77jni3f">
          Accès numérique immédiat · Accès à vie
        </p>

        <figure className="relative mt-5 w-full max-w-[680px] sm:mt-8" data-id="element-132" data-mp="30fybq32wpe0x">
          <div className="relative overflow-hidden rounded-[20px] bg-paper shadow-[0_20px_45px_-22px_rgba(31,36,48,0.28)] sm:rounded-[26px]" data-id="element-133" data-mp="35aaueawk6lbm">
            <img src="https://cdn.magicpatterns.com/uploads/mcPaTiZzZ2bypp9g298Npi/ChatGPT_Image_16_ago_2026,_09_52_14_p.m..png" alt="Professeure de physique-chimie tenant la bibliothèque CHIMIE VISUELLE™, avec les cinq volumes pédagogiques sur l’étagère" width="1656" height="928" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-134" data-mp="2viy3pmmhy176" />
            <div className="pointer-events-none absolute inset-0 rounded-[20px] ring-1 ring-inset ring-white/45 sm:rounded-[26px]" aria-hidden="true" data-id="element-135" data-mp="id04msaoe8p6" />
          </div>
        </figure>

        <p className="mt-5 max-w-xl text-[13px] leading-relaxed text-ink/75 sm:mt-6 sm:text-base" data-id="element-136" data-mp="1b04a0ydokp1h">
          Schémas, fiches visuelles, activités, séquences, évaluations et corrigés réunis dans une
          seule bibliothèque, classée par notion et par usage.
        </p>

        <div className="mt-6 flex w-full max-w-md flex-col items-center sm:mt-8" data-id="element-137" data-mp="x0csworvasj9">
          <p className="font-serif-display text-4xl font-bold leading-none text-cobalt sm:text-5xl" data-id="element-138" data-mp="3lt73mli5bhrm">
            19 €
          </p>
          <p className="mt-1.5 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-139" data-mp="3hq24msx9xy7q">
            Paiement unique · Accès à vie
          </p>
          <div className="mt-4 w-full" data-id="element-140" data-mp="21awdg8y8grgf">
            <CTAButton label="ACCÉDER À CHIMIE VISUELLE™" data-id="element-141" data-mp="21bxzf8gseycx" />
          </div>
        </div>

        <ul className="mt-6 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-cobalt/30 bg-white sm:mt-8 sm:grid-cols-4" data-id="element-142" data-mp="269r2hsmsnc8z">
          {reassurances.map((item, index) => <li key={item.label} className={`flex flex-col items-center gap-2 px-4 py-4 sm:py-5 ${index % 2 !== 0 ? 'border-l border-cobalt/20' : ''} ${index >= 2 ? 'border-t border-cobalt/20' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-143" data-mp="2g0c29je7emth" data-mpi={index}>
              <item.icon className="h-5 w-5 text-cobalt" aria-hidden="true" data-id="element-144" data-mp="2tyino01yuuc9" />
              <span className="text-[11px] font-medium leading-snug text-ink sm:text-sm" data-id="element-145" data-mp="umzfhnohlq3n">
                {item.label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}